import React, { useMemo, ForwardedRef, ReactElement } from 'react';
import MenuItem from '../menu-item/menu-item.component';
import CheckAccess from '../check-access/check-access.component';
import ActionButtonNewItem from '../action-button-new-item/action-button-new-item.component';

const MenuItemAddNewItem: ReactMemoComponent = React.memo(React.forwardRef((
  props: ReactComponentProps,
  ref: ForwardedRef<HTMLLIElement>,
): ReactElement => {
  const ROLE_OPTION: string = 'option';
  const ITEM_ID_NEW: number = 0;

  const {
    label,
    createPermission,
    onClick,
  } = props;

  const createPermissions: string[] = useMemo((): string[] => (
    createPermission ? [createPermission] : []
  ), [createPermission]);

  return (
    <CheckAccess permissions={createPermissions}>
      <MenuItem
        ref={ref}
        role={ROLE_OPTION}
        value={ITEM_ID_NEW}
        onClick={onClick}
      >
        <ActionButtonNewItem withNoHighlight label={label} />
      </MenuItem>
    </CheckAccess>
  );
}));

export default MenuItemAddNewItem;
